/**
 * Origem de campanha do cadastro de um tenant (utm_*), gravada no registro e
 * somente leitura no backoffice. Change landing-acquisition-tracking.
 */
export interface TenantAcquisition {
  source: string | null;
  medium: string | null;
  campaign: string | null;
  content: string | null;
  term: string | null;
}

export interface AcquisitionSummaryRow {
  source: string | null;
  medium: string | null;
  campaign: string | null;
  count: number;
}

export interface AcquisitionSummary {
  from: string;
  to: string;
  total: number;
  rows: AcquisitionSummaryRow[];
}

/** Valor do filtro `source` da API que seleciona os cadastros sem campanha. */
export const NO_CAMPAIGN_SOURCE = '-';

export const NO_CAMPAIGN_LABEL = 'Sem campanha (acesso direto)';

/** "instagram · pago · teste-1", ou o rótulo de acesso direto. */
export function describeAcquisition(acquisition: TenantAcquisition | null | undefined): string {
  if (!acquisition) return NO_CAMPAIGN_LABEL;
  const parts = [acquisition.source, acquisition.medium, acquisition.campaign].filter(Boolean);
  return parts.length ? parts.join(' · ') : NO_CAMPAIGN_LABEL;
}

export function sourceFilterLabel(source: string): string {
  return source === NO_CAMPAIGN_SOURCE ? NO_CAMPAIGN_LABEL : source;
}
